/* eslint-disable */

import React, { SVGProps } from "react";
import { Collapse, Text } from "@chakra-ui/react";
// eslint-disable-next-line max-len
import {
  ChevronDownIcon,
  ChevronUpIcon,
  ColorSwatchIcon,
  BeakerIcon,
  BookOpenIcon,
  LibraryIcon,
  ClipboardCheckIcon,
  ClipboardCopyIcon,
  GlobeIcon,
  GlobeAltIcon,
  LogoutIcon,
  HomeIcon,
  BellIcon,
  SpeakerphoneIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/outline";
import { Link, useRouteMatch } from "react-router-dom";
import clsx from "clsx";
import { useBaseLayoutStore } from "@app/stores";

interface MenuItemProps {
  url: string;
  title: string;
  icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  divider?: boolean;
  paths?: string[];
  children?: Pick<MenuItemProps, "url" | "title" | "paths">[];
}

const menus: MenuItemProps[] = [
  {
    url: "/banner",
    title: "Banner",
    icon: ClipboardCheckIcon,
    paths: ["/banner"],
  },
  {
    url: "/news",
    title: "Informasi Terbaru",
    icon: SpeakerphoneIcon,
    paths: ["/news"],
  },
  {
    url: "/faq",
    title: "FAQ",
    icon: QuestionMarkCircleIcon,
    paths: ["/faq"],
  },
  {
    url: "/notification",
    title: "List Notifikasi",
    icon: BellIcon,
    paths: ["/notification"],
  },
];

export const Sidebar = React.memo(() => {
  const routeMatch = useRouteMatch();
  const { isSlight, expandedMenu, setIsSlight, setExpandedMenu } =
    useBaseLayoutStore((state) => ({
      isSlight: state.isSlight,
      setIsSlight: state.setIsSlight,
      expandedMenu: state.expandedMenu,
      setExpandedMenu: state.setExpandedMenu,
    }));

  return (
    <div
      className={clsx(
        "sticky bg-white top-0 z-20 h-screen border-r border-gray-200 flex flex-col",
        { "min-w-[256px]": !isSlight, "w-[60px]": isSlight }
      )}
      // style={{ boxShadow: '2px 0px 6px rgba(0, 0, 0, 0.06)' }}
    >
      {/* logo section */}
      <div className="flex items-center h-[60px]">
        <div className="w-[60px] flex items-center justify-center">
          <img src="/assets/icon/logo.svg" />
        </div>
        {!isSlight && <img src="/assets/icon/logo_desc.svg" />}
      </div>

      {/* menu section */}
      <div className="mt-4">
        {menus.map((menu, i) => {
          const MenuIcon = menu.icon;

          if (menu.divider)
            return <div className="w-full h-[1px] bg-gray-300 my-4" key={i} />;

          if (menu.children?.length) {
            const isActive = menu.children.some((n) =>
              n.paths?.includes(routeMatch.path)
            );
            const isExpanded = expandedMenu === i || isActive;

            return (
              <React.Fragment key={i}>
                <div
                  key={i}
                  onClick={() => {
                    if (isSlight) {
                      setExpandedMenu(i);
                      setIsSlight(false);
                    } else if (!isActive)
                      setExpandedMenu(isExpanded ? null : i);
                  }}
                  className={clsx(
                    "relative flex items-center h-12 text-sm text-gray-700 cursor-pointer hover:bg-blueGray-100 hover:text-lightBlue-500",
                    {
                      "text-lightBlue-500 bg-blueGray-100": isActive,
                      "justify-center": isSlight,
                      "pl-5 pr-3": !isSlight,
                    }
                  )}
                >
                  {MenuIcon && <MenuIcon className="w-5" />}
                  {!isSlight && (
                    <Text className="ml-3 mr-auto capitalize">
                      {menu.title}
                    </Text>
                  )}
                  {!isSlight &&
                    (isExpanded ? (
                      <ChevronUpIcon className="w-4" />
                    ) : (
                      <ChevronDownIcon className="w-4" />
                    ))}
                  {isActive && (
                    <div className="absolute left-0 h-full bg-lightBlue-500 w-[4px]" />
                  )}
                </div>
                <Collapse in={isExpanded && !isSlight} animateOpacity>
                  <div className="text-sm text-gray-700">
                    {menu.children.map((child, childKey) => {
                      const isChildActive = child.paths?.includes(
                        routeMatch.path
                      );
                      return (
                        <Link
                          to={child.url}
                          key={childKey}
                          className={clsx(
                            "pl-[52px] flex items-center h-10 cursor-pointer hover:text-lightBlue-500",
                            {
                              "text-lightBlue-500 bg-blueGray-50":
                                isChildActive,
                            }
                          )}
                        >
                          {child.title}
                        </Link>
                      );
                    })}
                  </div>
                </Collapse>
              </React.Fragment>
            );
          }

          const isActive = menu.paths?.includes(routeMatch.path);

          return (
            <Link
              to={menu.url}
              key={i}
              className={clsx(
                "relative flex items-center h-12 text-sm text-gray-700 cursor-pointer hover:bg-blueGray-100 hover:text-lightBlue-500",
                {
                  "text-lightBlue-500 bg-blueGray-100": isActive,
                  "justify-center": isSlight,
                  "px-5": !isSlight,
                }
              )}
            >
              {MenuIcon && <MenuIcon className="w-5" />}
              {!isSlight && (
                <Text className="ml-3 capitalize">{menu.title}</Text>
              )}
              {isActive && (
                <div className="absolute left-0 h-full bg-lightBlue-500 w-[4px]" />
              )}
            </Link>
          );
        })}
      </div>
      {/* //! Logout */}
      <div className="mt-36 border-t-2"></div>
      <Link
        to="/login"
        className="relative flex items-center h-12 text-sm text-gray-700 cursor-pointer hover:bg-blueGray-100 hover:text-lightBlue-500 pl-5"
      >
        <LogoutIcon className="w-5" />
        {!isSlight && <Text className="ml-3 capitalize">Logout</Text>}
      </Link>
      {/* toggle section */}
      <div
        onClick={() => setIsSlight(!isSlight)}
        className={clsx(
          "flex items-center h-12 mt-auto text-sm text-gray-400 cursor-pointer hover:text-lightBlue-500",
          {
            "text-lightBlue-500": isSlight,
            "justify-center": isSlight,
            "px-5": !isSlight,
          }
        )}
      >
        <ColorSwatchIcon className="w-5" />
        {!isSlight && <Text className="ml-3">Toggle sidebar</Text>}
      </div>
    </div>
  );
});
